module.exports = __webpack_public_path__ + "static/media/gill_versoDrysuit.6f3bf711.jpg";